import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Not all modules will be armed for a given game. Only the armed modules have to be disarmed to complete the game. ", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " Some modules might activate themselves again even after they have been disarmed. This depends on the game mode and difficulty level ", -1 /* HOISTED */)

import MorseCodeDocumentation from "@src/modules/Documentation/components/MorseCodeDocumentation.vue";
import WireMatcherDocumentation from "@src/modules/Documentation/components/WireMatcherDocumentation.vue";
import NumberDecoderDocumentation from "@src/modules/Documentation/components/NumberDecoderDocumentation.vue";
import BinaryLogicDocumentation from "@src/modules/Documentation/components/BinaryLogicDocumentation.vue";
import SimonSaysDocumentation from "@src/modules/Documentation/components/SimonSaysDocumentation.vue";
import TimerDocumentation from "@src/modules/Documentation/components/TimerDocumentation.vue";
import LabyrinthDocumentation from "@src/modules/Documentation/components/LabyrinthDocumentation.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Documentation',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    width: "1000px",
    class: "docs-container pb-15"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h3 font-weight-bold mt-6 text-center" }, {
        default: _withCtx(() => [
          _createTextVNode("BMB DISARMING MANUAL")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_card_text, { class: "text-body-1 mt-3" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(TimerDocumentation),
      _createVNode(LabyrinthDocumentation),
      _createVNode(SimonSaysDocumentation),
      _createVNode(NumberDecoderDocumentation),
      _createVNode(MorseCodeDocumentation),
      _createVNode(WireMatcherDocumentation),
      _createVNode(BinaryLogicDocumentation)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})